import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BiReset } from "react-icons/bi";

import { print_state, print_city, state_arr } from "../../Utility/stateCity";
import Spinner from "react-bootstrap/Spinner";
import { ImFileMusic } from "react-icons/im";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { BiDotsVerticalRounded } from "react-icons/bi";

export function DeceasedAnimalBurialGrounds(props) {
  useEffect(() => {
    // props.Auth();
  }, []);
  const [show, setShow] = useState(false);
  const [Id, setId] = useState();
  const handleShow = () => setShow(true);

  const handleClose = () => {
    setShow(false);
    setId("");
  };

  const [first, setfirst] = useState(false);
  const [data, setdata] = useState(false);
  const [cat, setCat] = useState(false);

  const [load, setload] = useState(false);
  const [error, seterror] = useState("");
  const [output, setoutput] = useState([]);
  const [Keyer, setKeyer] = useState(1);
  const [Stateload, setStateload] = useState(true);

  const [value, setValue] = useState({
    state: "",
    city: "",
    pincode: "",
    // WE:false
  });

  function Cityshow(e) {
    var index = document.getElementById(e.target.id).selectedIndex;
    print_city("City", index);
    setValue({ ...value, state: e.target.value });
  }
  useEffect(() => {
    if (Stateload) print_state("State");
    setStateload(false);
  }, []);

  const vaid = () => {
    if (value.state.length > 0) {
      seterror("");
    } else {
      return seterror("Please select a state");
    }
    if (value.city.length > 0) {
      seterror("");
    } else {
      return seterror("Please select a city");
    }
    return true;
  };
  const Reset = (e) => {
    document.getElementById("searchForm").reset();
    setValue({ ...value, city: "", state: "", WE: !value.WE, pincode: "" });
    // Club();
    GetAmbuianceAnimal();
  };
  const GetAmbuianceAnimal = (last) => {
    setload(true);
    console.log("page");
    axios
      .get("/api/User/GetDeceasedAnimalBurialGrounds")
      .then((response) => {
        // axios.get("/api/User/ReferCount")
        setload(false);
        console.log("heree");
        console.log(response);
        setoutput(response.data);
      })
      .catch((res) => {
        setload(false);
        console.log("Something went wrong");
      });
  };

  useEffect(() => {
    GetAmbuianceAnimal();
  }, []);

  const FindAmbuianceAnimal = (last) => {
    // console.log(page)
    setload(true);

    axios
      .post("/api/User/FindDeceasedAnimalBurialGrounds", { value })
      .then((response) => {
        setload(false);
        console.log("first");
        console.log(response.data);
        setoutput(response.data);
      })
      .catch((res) => {
        setload(false);
        console.log("Something went wrong");
      });
  };
  const [index, setindex] = useState();
  const Delete = () => {
    console.log(Id);
    console.log(index);

    var id = Id;
    axios
      .post("/api/Admin/DeceasedAnimalBurialGroundsDelete", { id })
      .then((response) => {
        // console.log('success')
        if (response.status === 200) {
          //   console.log("reported11")
          // setreported(true)
          // window.location.reload();
          let temp = [...output];
          temp.splice(index, 1);
          setindex(undefined);
          setId("");
          setoutput(temp);
          handleClose();
        }
      })
      .catch((res) => {
        console.log("Something went wrong");
      });
  };

  return (
    <div className="container-fluid bg-trasparent  wieugfiqgefnqenc2rnewiuhgiuhq ">
      <div>
        {localStorage.getItem("Type") === "sponsored" ? (
          <div className="d-flex justify-content-end">
            <Link to="/DeceasedAnimalBurialGroundsReg">
              <button className="btn btn-dosabutton ps-3 pe-3 mb-3 deghievgviehcieh">
                Add New
              </button>
            </Link>
          </div>
        ) : (
          ""
        )}
      </div>
      {/* <div className="d-flex justify-content-end">
        <Link
          to={"/home/Vendor_Result2?Sub_id=" + id}
          className="btn pro-spaces-button me-1 ps-3 pe-3"
          style={{"textTransform":"none"}}
        >
          ACTIVE Profiles
        </Link>
      </div>
      <hr /> */}
      {/* <center><h5 className="parapara">PRO-ACTIVE Profiles</h5></center> */}

      <div id="AdvancedSearch" className=" row bg-light  p-2 m-2 mb-4">
        <div>
          <p>Advanced Search Filters</p>
        </div>
        <form id="searchForm">
          <div className="col-12 ">
            <div className="row g-1">
              <div className="col-6 col-lg-3">
                <div className="form-floating">
                  <select
                    className="form-select   "
                    value={value.state}
                    id="State"
                    name="City"
                    onChange={(e) => Cityshow(e)}
                  ></select>
                  <label htmlFor="State">State</label>
                </div>
              </div>
              <div className="col-6 col-lg-3">
                <div className="form-floating">
                  <select
                    className="form-select   "
                    name="City"
                    value={value.city}
                    id="City"
                    onChange={(e) =>
                      setValue({ ...value, city: e.target.value })
                    }
                  ></select>
                  <label htmlFor="City">City</label>
                </div>
              </div>

              <div className="col-6 col-lg-3">
                <div className="form-floating">
                  <input
                    type="number"
                    className="form-control"
                    name="pin"
                    value={value.pincode}
                    id="a"
                    onChange={(e) =>
                      setValue({ ...value, pincode: e.target.value })
                    }
                  ></input>
                  <label htmlFor="a">Pin&nbsp;code</label>
                </div>
              </div>

              {/* <div className="col-6 col-lg-3 pt-2">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    onChange={(e) => setValue({ ...value, WE: !value.WE })}
                    id="flexCheckCheckedEntrepreneur"
                  />
                  <label
                    class="form-check-label"
                    for="flexCheckCheckedEntrepreneur"
                  >
                    Woman Entrepreneur
                  </label>
                </div>
              </div> */}
            </div>
          </div>
          <div className="col-12 col-md-12 mb-1 mt-2">
            <div className=" d-flex justify-content-end">
              <div className="   me-2 ">
                <button
                  className="btn btnjui2 ps-4 pe-4 d-flex justify-content-center"
                  type="button"
                  onClick={(e) => Reset(e)}
                >
                  <BiReset size={24} />
                </button>
              </div>
              <button
                type="button"
                className="btn btnjui "
                onClick={(e) => FindAmbuianceAnimal()}
              >
                Go
              </button>
            </div>

            <span style={{ color: "red" }}>{error ? error : ""}</span>
          </div>
        </form>
      </div>

      {/* <div>  
          <center><button className="btn pro-spaces-button3" id="tooglebutton" onClick={(e)=>setfirst(!first)}>{first?'Show Vendors Only':'Show Products Only'}</button></center>
        </div> */}

      <div className="row car">
        {" "}
        {load ? (
          <center>
            <Spinner animation="border" />
          </center>
        ) : output.length ? (
          output.map((elem, index) => {
            return (
              <>
                <div className=" col-12 col-md-6 col-lg-6 col-xl-4  mb-3">
                  <div className="text-center card-box p-0">
                    <div className="member-card pt-3 pb-0">
                      <div className="d-flex justify-content-end">
                        {localStorage.getItem("Type") === "sponsored" ? (
                          <a
                            type="button"
                            href="/"
                            className="dotoptionbtn   cell"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <BiDotsVerticalRounded
                              size={35}
                              onClick={(e) => {
                                setId(elem._id);
                                setindex(index);
                              }}
                              color={"black"}
                            ></BiDotsVerticalRounded>
                          </a>
                        ) : (
                          <></>
                        )}
                        <ul className="dropdown-menu ">
                          <li>
                            <Link
                              to={
                                "/DeceasedAnimalBurialGroundsEdit?pi=" +
                                elem._id
                              }
                              className="dropdown-item"
                            >
                              Edit post
                            </Link>
                          </li>
                          <li>
                            <a className="dropdown-item" onClick={handleShow}>
                              {" "}
                              Delete
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className="row mb-2">
                        <div className="col d-flex justify-content-center">
                          {/* 
                <span className="puskaran">PRO-</span>&nbsp;<span className="">VERIFIED CONSULTANT</span> */}
                        </div>
                      </div>
                      <div className="">
                        <h4>
                          {/* {props.data
                    ? props.data.firstname.toUpperCase() : ""} {props.data.lastname?props.data.lastname.toUpperCase():''} */}
                          {elem.name.toUpperCase()}
                        </h4>
                        <p className="ufghsuhie rigehioerhog">
                          {/* <br /> */}
                          <span>
                            <p className="ufghsuhie">
                              {elem.state} | {elem.city}
                            </p>

                            <div className="row">
                              <div className="entityJobs col-4">
                                <b>PIN CODE </b>
                                <p className="ms-2 JobVal">{elem.pincode}</p>
                              </div>

                              <div className="entityJobs col-4">
                                <b>SERVICE CHARGES </b>

                                <p className="ms-2 JobVal">
                                  {elem.ServiceCharges}/-
                                </p>
                              </div>

                              <div className="entityJobs col-4">
                                <b>PHONE</b>
                                <p className="ms-2 JobVal">{elem.phone}</p>
                              </div>
                            </div>
                            <div className="ps-2 pe-2">
                              <center>
                                <hr
                                  style={{ width: "50%", marginLeft: "10" }}
                                />
                              </center>
                            </div>
                            <b>LOCATIONS</b>
                            <br />

                            {elem.locations
                              ? elem.locations.map((elem2, index) => {
                                  var a = elem.locations.length;
                                  return (
                                    <span>
                                      {elem2}
                                      {index === a - 1 ? "" : ", "}
                                    </span>
                                  );
                                })
                              : ""}

                            <div className="ps-2 pe-2">
                              <center>
                                <hr
                                  style={{ width: "50%", marginLeft: "10" }}
                                />
                              </center>
                            </div>
                            <b>SERVICES PROVIDED</b>
                            <br />
                            <p>{elem.ServicesProvided}</p>
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <Modal
                  show={show}
                  onHide={handleClose}
                  backdrop={false}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Deleting post </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <h6>Are you sure ?</h6>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      className="btn pro-spaces-button3"
                      onClick={(e) => Delete()}
                    >
                      Delete
                    </button>
                  </Modal.Footer>
                </Modal>
              </>
            );
          })
        ) : (
          <>
            <center>
              <h4>No Result Found !</h4>
            </center>
          </>
        )}
      </div>

      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}
